(function () {
  function applyDiscount(form) {
    const input = form.querySelector('input[name="discount"]');
    if (!input) return;
    const code = (input.value || '').trim();
    if (!code) return;
    const redirect = encodeURIComponent('/checkout');
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirect}`;
  }

  function bindDiscountForms(root) {
    root.querySelectorAll('[data-cuatro-discount-form]').forEach((form) => {
      if (form.dataset.cuatroDiscountBound === 'true') return;
      form.dataset.cuatroDiscountBound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        applyDiscount(form);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindDiscountForms(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    bindDiscountForms(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('cart-drawer') || node.querySelector?.('cart-drawer')) {
          bindDiscountForms(node.matches?.('cart-drawer') ? node : node.querySelector('cart-drawer'));
        }
        if (node.querySelector?.('[data-cuatro-discount-form]')) {
          bindDiscountForms(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
